<template>
  <div @click="$emit('click')" class="slashable-icon">
    <img class="slashable-img" :src="img" v-b-tooltip.hover
              :title="popover"/>
    <img class="slash-icon" src="/static-appopensalud/img/icons/slash-white.svg" v-if="slashed"/>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true
    },
    slashed: {
      type: Boolean,
      required: true
    },
    popover: {
      type: String,
      required: false,
      default: null
    }
    /* onClick: {
      type: Function,
      required: true
    } */
  }
}
</script>

<style lang="scss" scoped>
  

  .slashable-icon {
    @include rounded-btn;
    -webkit-transition: -webkit-box-shadow 0.2s ease-in-out;
    transition: -webkit-box-shadow 0.2s ease-in-out;
    transition: box-shadow 0.2s ease-in-out;
    transition: box-shadow 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;
    cursor: pointer;
    display: inline-block;
  }
  
  .slashable-img {
    width: 100%;
  }

  .slash-icon {
    width: 30px;
    margin: 10px -40px;
    position: absolute;
  }
</style>


// WEBPACK FOOTER //
// src/components/base/ui/SlashableIcon.vue